// extracted by mini-css-extract-plugin
export var wordContainer = "_qg-0";